import {AiExtractionPriceBreakdown, TokenUsage} from "./VulSourceItem";

class VulReportAiSummary {
    constructor(
        public id?: string,
        public reportId?: string,
        public summarizerId?: string,
        public createdAt?: Date,
        public startedAt?: Date,
        public finishedAt?: Date,
        public status?: VulReportAiSummaryStatus,
        public summary?: string,
        public itemGroups?: VulReportAiSummaryGroup[],
        public errorMessage?: string,
        public inputItemCount?: number,
        public inputHash?: string,
        public reportGeneratedAt?: Date,
        public summarizerName?: string,
        public summarizerType?: string,
        public model?: string,
        public openAiServiceTier?: string,
        public systemPromptId?: string,
        public supplementaryPromptId?: string,
        public tokenUsage?: TokenUsage,
        public executionTimeMs?: number,
        public reasoningSummary?: unknown[],
        public toolTelemetry?: unknown,
        public priceBreakdown?: AiExtractionPriceBreakdown,
        public price?: number,
        public apiCallCount?: number,
        public webSearchCallCount?: number,
        public aiProviderCommunicationRunId?: string,
        public stale?: boolean) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const summary = new VulReportAiSummary();

        summary.id = data.id;
        summary.reportId = data.reportId;
        summary.summarizerId = data.summarizerId;
        summary.createdAt = data.createdAt ? new Date(data.createdAt) : undefined;
        summary.startedAt = data.startedAt ? new Date(data.startedAt) : undefined;
        summary.finishedAt = data.finishedAt ? new Date(data.finishedAt) : undefined;
        summary.status = data.status;
        summary.summary = data.summary;
        summary.itemGroups = Array.isArray(data.itemGroups) ? data.itemGroups : undefined;
        summary.errorMessage = data.errorMessage;
        summary.inputItemCount = data.inputItemCount;
        summary.inputHash = data.inputHash;
        summary.reportGeneratedAt = data.reportGeneratedAt ? new Date(data.reportGeneratedAt) : undefined;
        summary.summarizerName = data.summarizerName;
        summary.summarizerType = data.summarizerType;
        summary.model = data.model;
        summary.openAiServiceTier = data.openAiServiceTier;
        summary.systemPromptId = data.systemPromptId;
        summary.supplementaryPromptId = data.supplementaryPromptId;
        summary.tokenUsage = data.tokenUsage;
        summary.executionTimeMs = data.executionTimeMs;
        summary.reasoningSummary = data.reasoningSummary;
        summary.toolTelemetry = data.toolTelemetry;
        summary.priceBreakdown = data.priceBreakdown;
        summary.price = data.price;
        summary.apiCallCount = data.apiCallCount;
        summary.webSearchCallCount = data.webSearchCallCount;
        summary.aiProviderCommunicationRunId = data.aiProviderCommunicationRunId;
        summary.stale = data.stale;

        return summary;
    }

    public isRunning() {
        return this.status === "PENDING" || this.status === "RUNNING";
    }
}

export type VulReportAiSummaryStatus = "NOT_GENERATED" | "PENDING" | "RUNNING" | "DONE" | "FAILED";

export interface VulReportAiSummaryGroup {
    title?: string;
    basis?: string;
    itemIds?: string[];
    itemCount?: number;
}

export default VulReportAiSummary;
